// IntroLogoAnimation.jsx
import React, { useEffect, useState, useRef } from "react";

export default function IntroLogoAnimation({ targetRef }) {
  const [active, setActive] = useState(true);
  const introLogoRef = useRef(null);

  useEffect(() => {
    const logo = introLogoRef.current;
    const target = targetRef.current;
    if (!logo || !target) return;

    // 1️⃣ WAIT 1 SECOND before starting motion
    const startTimer = setTimeout(() => {
      const logoRect = logo.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      const diffX = targetRect.left - logoRect.left;
      const diffY = targetRect.top - logoRect.top;
      const scale = targetRect.width / logoRect.width;

      requestAnimationFrame(() => {
        logo.style.transform = `
          translate(${diffX}px, ${diffY}px)
          scale(${scale})
        `;
        logo.style.opacity = "0";
      });
    }, 500); // <-- stays for 0.5 second

    // 2️⃣ Remove overlay after animation finishes
    const removeTimer = setTimeout(() => {
      setActive(false);
    }, 2000); // 1s delay + 2s animation + 0.6 fade

    return () => {
      clearTimeout(startTimer);
      clearTimeout(removeTimer);
    };
  }, [targetRef]);

  return (
    <>
      <style>
        {`
          .intro-wrapper {
            transition: opacity 0.6s ease;
          }
          .intro-logo {
            transition:
              transform 1.5s cubic-bezier(0.22, 1, 0.36, 1),
              opacity 1s ease;
            will-change: transform, opacity;
          }
        `}
      </style>

      <div
        className={`
          fixed inset-0 flex items-center justify-center
          bg-white z-[200]
          intro-wrapper
          ${active ? "opacity-100" : "opacity-0 pointer-events-none"}
        `}
      >
        <img
          ref={introLogoRef}
          src="/savvytron-logo.png"
          alt="SavvyTron logo"
          className="intro-logo w-40 sm:w-56"
        />
      </div>
    </>
  );
}
